import React from 'react';
import { useAuthStore } from '../store/store';
import { useQuery } from '@tanstack/react-query';
import { getCheckInPeriods } from '../api/dashboard.js';
import ClipLoader from 'react-spinners/ClipLoader';
import UserTrend from '../components/userDashboard/UserTrend';
import UserDistribution from '../components/userDashboard/UserDistribution';

const UserDashboard = () => {
    const uid = useAuthStore(store => store.user?.uid);

    const checkInPeriodsQuery = useQuery({
        queryKey: ['checkInPeriods', uid],
        queryFn: () => getCheckInPeriods(uid),
        enabled: !(uid === null || uid === undefined),
    });

    if (checkInPeriodsQuery.isLoading) {
        return (
            <div className='loading'>
                <ClipLoader
                    loading={checkInPeriodsQuery.isLoading}
                    size={100}
                    aria-label='Loading Spinner'
                />
            </div>
        );
    }

    if (checkInPeriodsQuery.isError || Object.keys(checkInPeriodsQuery.data).length === 0) {
        return (
            <div className='py-3 px-5 my-10'>
                <p className='text-center'>You have not checked in yet. Please check in to view your mood and stress level summary.</p>
            </div>
        );
    }

    return (
        <div className='py-3 px-5 my-3'>
            <UserTrend checkInPeriodsQuery={checkInPeriodsQuery}/>
            <UserDistribution checkInPeriodsQuery={checkInPeriodsQuery}/>
        </div>
    );
};

export default UserDashboard;
